import React from "react";

const TermsOfService = () => {
  return (
    <div className="pt-[70px] text-[#3B2E22] bg-[#dbc3ab] md:bg-[#f7dbb6]  mx-auto px-6 py-12 md:px-20 text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
      <p className="mb-4 text-sm text-gray-600">
        Effective Date: August 5, 2025
      </p>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">1. Use of Services</h2>
        <p>
          Our services are designed to help individuals grow through freelancing
          training and strategy. You must be 18+ and agree to use our services
          legally and ethically.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">2. Payments & Refunds</h2>
        <p>
          All payments made are <strong>non-refundable</strong>. Full payment is
          required to access paid services. Prices may change without notice.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">3. Free Audit Calls</h2>
        <p>
          Our free 15-minute audit call helps determine your fit for the
          freelancing program. You’ll receive details via WhatsApp and email.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">4. Content Ownership</h2>
        <p>
          All training materials are the property of The PR Media & GoWappily
          Infotech. Unauthorized use is prohibited.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">5. User Responsibility</h2>
        <p>
          You’re responsible for the accuracy of your information. Misuse may
          result in access restrictions or permanent ban.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">6. Changes to Terms</h2>
        <p>
          We may update our terms at any time. Continued use implies acceptance
          of updates.
        </p>
      </section>

      <section>
        <h2 className="text-xl font-semibold mb-2">7. Contact</h2>
        <p>
          📍 Office No-109, Second Floor, Om Tower, Commercial Belt, Alfa-1,
          Near Pari Chowk, Greater Noida, 201310
          <br />
          📞 7500010933, 7500030415
        </p>
      </section>
    </div>
  );
};

export default TermsOfService;
